<template lang="pug">
.el-input
  label.el-input__inner
    el-tag(size="medium", :type="dept.isMain ? 'success' : 'default'", v-for="dept in value", :key="dept.deptId") {{ dept.deptName }}
</template>
<script>
export default {
  props: {
    readonly: { default: true, type: Boolean },
    value: { default: () => [], type: Array }
  },
  data() {
    return { visible: false };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    submit() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-tag {
  margin: 3px 6px 3px 0;
}
.el-input__inner {
  display: flex;
  flex-flow: row wrap;
  min-height: 40px;
  height: auto;
  padding: 2px 8px;
}
.el-icon-edit {
  cursor: pointer;
}
</style>
